import React, {useEffect, useState} from 'react';
import {style} from "../styles";
import {Briefcase} from "../../../assets";
import {ProjectCard} from "./ProjectCard";
import {getProjects, ProjectCardType, ProjectsType} from "../../../axios/api";

const Projects = () => {
    const [data, setData] = useState<ProjectCardType[] | null>(null)

    useEffect(() => {
        getProjects().then(setInfo).catch(console.error);
    }, []);

    const setInfo = (d: ProjectsType) => {
        setData(d.results)
    }

    return (
        <div className={style.container}>
            <h2 className={style.title}><img src={Briefcase}/>Проекты и заказчики</h2>
            <div className={style.content}>
                {data?.map((item) => <ProjectCard key={item.id} project={item} />)}
            </div>
        </div>
    );
};

export {Projects};